import useUserMe from "./useUserMe";

const useExpertOwner = ({ expertId }) => {
  const { user } = useUserMe();

  return user.expert?.id === expertId;
};

export default useExpertOwner;
